// @mui
import {
  Typography,
  Box,
  Stack,
  Button,
  CircularProgress,
  Popover,
  Chip,
  Grid,
  InputLabel,
  TextField,
  // RadioGroup,
  // FormControlLabel,
  // Radio,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';

import { useMemo, useState } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { mockSlots } from '../../mock/slotsData';
import { activeSnack } from '../../server/store/common';
import { useDevice } from '../../hooks/useResponsive';
import { colors } from '../../theme/colors';

// import Banner from '../../../public/assets/images/Booking/bookingBanner.png'
// components

BookingDialog.propTypes = {};

export default function BookingDialog() {
  const dispatch = useDispatch();

  const slotList = { response: mockSlots };
  const [submitting, setSubmitting] = useState(false);
  const loading = submitting;
  // const [payment, setPayment] = useState('method2');

  const [selectedDate, setSelectedDate] = useState(moment().add(1, 'day'));
  // const [markers, setMarkers] = useState();
  // console.log(markers, 'markers>>>>>>');

  const [sessionValue, setSessionValue] = useState('');
  const [selectedTimeLabel, setSelectedTimeLabel] = useState('');

  // const theme = useTheme();
  const { isMobile } = useDevice();

  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  // calender functions
  const today = moment(selectedDate).format('yyyy-MM-DD');
  const oneWeek = moment().add(6, 'days');

  // const dayName = moment(selectedDate).format('dddd');
  // const currentDate = moment(selectedDate).format('MMMM D');
  const dayName = moment(selectedDate).format('ddd'); // e.g. Mon
  const currentDate = moment(selectedDate).format('D-MMM'); // e.g. 3-Mar

  // const currentYear = moment(selectedDate).format('yyyy');

  const filteredSessions = slotList?.response?.filter((item) => item?.date === today);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: '',
      phone: '',
      email: '',
      address: '',
    },
  });

  const onSubmit = async (value, e) => {
    e?.preventDefault();
    setSubmitting(true);
    try {
      const payload = {
        name: value.name,
        email: value.email,
        phone: value.phone,
        address: value.address,
        booking_date: moment(selectedDate).format('YYYY-MM-DD'),
        booking_time: selectedTimeLabel || sessionValue || 'Not Selected',
      };

      const response = await fetch('/api/booking.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const resData = await response.json();

      if (response.ok && resData.status === 'success') {
        dispatch(
          activeSnack({
            type: 'success',
            message: resData.message || 'Booked successfully! Our expert will visit you soon.',
          })
        );
        reset();
        setSessionValue('');
        setSelectedTimeLabel('');
      } else {
        dispatch(
          activeSnack({
            type: 'error',
            message: resData.message || 'Failed to submit booking. Please try again.',
          })
        );
      }
    } catch (err) {
      dispatch(
        activeSnack({
          type: 'error',
          message: 'Network error. Please try again later.',
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  const CustomButton = styled(Button)({
    background: colors.primary,
    color: 'white',
    borderRadius: '0',
    boxShadow: 'none',
    fontSize: '23px',
    fontWeight: '900',
    '&:hover': {
      background: colors.primary,
      color: 'white',
    },
  });

  const todayDate = moment().startOf('day').add(1, 'day');
  const dates = useMemo(
    () => Array.from({ length: 4 }, (_, i) => todayDate.clone().add(i, 'days')),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [todayDate.format('YYYY-MM-DD')]
  );

  const [anchorEl, setAnchorEl] = useState(null);

  const handleCalendarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCalendarClose = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);

  // const methods = [
  //   { label: '100% upfront', value: '100% upfront', miniText: '' },
  //   {
  //     label: '50% upfront (advance)',
  //     value: '50% upfront (advance)',
  //     miniText: 'Balance after successful completion.',
  //   },
  //   { label: '3 monthly instalments', value: '3 monthly instalments', miniText: 'No hidden charges.' },
  // ];
  // console.log('errors', errors);
  return (
    <>
      <Stack sx={{ padding: '20px 18px' }}>
        <Box sx={{ '& > *:not(:first-of-type)': { mt: 2 } }}>
          <Stack>
            <Typography mb={1} className="merri-weather-text-bold" sx={{ fontSize: '20px', color: 'black' }}>
              Schedule FREE Home Visit
            </Typography>
          </Stack>
          <Box
            component="img"
            src="/assets/images/Booking/bookingMobile.webp"
            alt="Banner"
            sx={{
              width: '100%',
              borderRadius: 2,
              mb: 2,
            }}
          />
        </Box>
        <Typography variant="subtitle1" className="roboto-sans-medium" fontWeight={500} mb={1}>
          Choose a Time Slot
        </Typography>

        {/* Time Slots */}
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={0.8} flexWrap="wrap">
            {dates.map((date, i) => {
              const isSelected = selectedDate && date.isSame(selectedDate, 'day');

              return (
                <Button
                  key={i}
                  onClick={() => {
                    setSelectedDate(date);
                  }}
                  variant={isSelected ? 'contained' : 'outlined'}
                  sx={{
                    minWidth: 50,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'unset',
                    color: isSelected ? '#white' : 'black',
                    backgroundColor: isSelected ? '#ec2927' : 'white',
                    borderColor: isSelected ? 'transparent' : '#b3b3b3',
                    py: 1,
                    borderRadius: '8px',
                    px: 'auto',
                    '&:hover': {
                      backgroundColor: '#ec2927',
                      color: 'white',
                    },
                    '@media (max-width:407px)': {
                      px: 1.5,
                    },
                    '@media (max-width:383px)': {
                      px: 1,
                    },
                  }}
                >
                  <Typography className="roboto-sans-regular" fontSize="11px">
                    {i === 0 ? 'Tomorrow' : date.format('ddd')}
                  </Typography>
                  <Typography className="roboto-sans-medium" fontSize="13px">
                    {date.format('DD-MMM')}
                  </Typography>
                </Button>
              );
            })}
          </Stack>
          {/* <IconButton onClick={handleCalendarClick} sx={{ alignSelf: 'center' }}>
              <CalendarMonthIcon />
            </IconButton> */}
          <Box display="flex" flexDirection="column" alignItems="center" ml={0} onClick={handleCalendarClick}>
            <Box
              component="img"
              src="/assets/images/Booking/calendar.png"
              alt="Example"
              sx={{
                width: 40,
                height: 40,
                objectFit: 'cover',
              }}
            />
            <Stack direction="row" spacing={0.5} ml={0.5} alignItems="center">
              <Typography fontSize={11} fontWeight={500}>
                More
              </Typography>
              <ArrowForwardIosIcon sx={{ fontSize: 10 }} />
            </Stack>
          </Box>
        </Stack>

        <Stack direction={isMobile ? 'column' : 'row'} alignItems={'center'} justifyContent={'space-between'} mt={2}>
          {selectedDate && filteredSessions?.[0] && (
            <Box sx={{ width: '100%' }}>
              {loading ? (
                <Stack className="slotLoading" sx={{ width: '100%', alignItems: 'center' }}>
                  <CircularProgress color="inherit" size={'50px'} />
                </Stack>
              ) : (
                <Stack direction="column" spacing={1} mb={3}>
                  {/* <Typography pb={1} variant="h4" color={'GrayText'} display={'flex'} justifyContent={'center'}>
                      {dayName}, {currentDate}, {currentYear}
                    </Typography> */}
                  {selectedDate && !dates.some((date) => date.isSame(selectedDate, 'day')) && (
                    <Chip
                      label={
                        <Typography sx={{ color: 'white', fontWeight: 'bold' }}>
                          <span className="roboto-sans-regular" style={{ fontSize: '13px' }}>
                            {dayName}{' '}
                          </span>
                          {''}
                          <span className="roboto-sans-medium" style={{ fontSize: '14px' }}>
                            {currentDate}
                          </span>
                        </Typography>
                      }
                      onDelete={() => {
                        // setSelectedDate(null);
                        setSelectedDate(moment().add(1, 'day'));
                      }}
                      deleteIcon={<CloseIcon sx={{ marginLeft: 2, fontSize: '16px', color: 'white' }} />}
                      sx={{
                        gap: 1.5,
                        bgcolor: '#ED2629',
                        color: 'white',
                        fontWeight: 'bold',
                        height: 32,
                        width: 'fit-content',
                        '& .MuiChip-deleteIcon': {
                          color: 'white',
                          '&:hover': {
                            color: '#ccc',
                          },
                        },
                      }}
                    />
                  )}

                  <Typography py={1} variant="subtitle1" className="roboto-sans-medium" fontWeight={500} mb={1}>
                    Time
                  </Typography>
                  {/* {filteredSessions?.[0] &&
                    filteredSessions?.[0]?.availableSessions &&
                    !filteredSessions?.[0]?.isHoliday ? ( */}
                  {Array.isArray(filteredSessions?.[0]?.availableSessions) &&
                  filteredSessions[0].availableSessions.length > 0 &&
                  !filteredSessions[0].isHoliday ? (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 1,
                        width: '100% !important',
                      }}
                    >
                      {filteredSessions?.[0]?.availableSessions?.map((item, key) => (
                        <Button
                          key={key}
                          variant="contained"
                          sx={{
                            width: '100%',
                            boxShadow: 'none',
                            borderRadius: '8px',
                            backgroundColor: item?.session === sessionValue ? '#ec2927' : 'white',
                            color: item?.session === sessionValue ? 'white' : 'black',
                            fontWeight: '350',
                            fontSize: '14px',
                            py: 1,
                            border: `1px solid ${item?.session === sessionValue ? 'transparent' : '#b3b3b3'}`,
                            '&:hover': {
                              backgroundColor: item?.session === sessionValue ? '#ec2927' : '#f5f5f5',
                              color: item?.session === sessionValue ? 'white' : 'black',
                            },
                            position: 'relative',
                            overflow: 'hidden',
                          }}
                          onClick={() => {
                            if (item?.availableAppoinmentCount > 0) {
                              setSessionValue(item?.session);
                              setSelectedTimeLabel(item?.timeFrom && item?.timeTo ? `${item.timeFrom} to ${item.timeTo}` : item?.session);
                              document.getElementById('scroll')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                          }}
                          disabled={item?.availableAppoinmentCount <= 0}
                        >
                          <span>
                            {item?.timeFrom} to&nbsp;{item?.timeTo}
                          </span>

                          {item?.availableAppoinmentCount <= 0 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '6px',
                                right: '-17px',
                                backgroundColor: '#9a9a9a',
                                color: 'white',
                                padding: '5px 5rem',
                                borderRadius: '12px',
                                fontSize: '8px',
                                fontWeight: '800',
                                transform: 'rotate(47deg)',
                                transformOrigin: 'center center',
                                marginRight: '-4rem',
                                letterSpacing: '1px',
                              }}
                            >
                              Booked
                            </span>
                          )}
                        </Button>
                      ))}
                    </Box>
                  ) : (
                    <Typography sx={{ textAlign: 'center' }}>NO AVAILABLE SESSIONS</Typography>
                  )}
                </Stack>
              )}
            </Box>
          )}
        </Stack>
        <Stack>
          <form onSubmit={handleSubmit((value, e) => onSubmit(value, e))} noValidate>
            <Grid container alignItems="center" spacing={1} mb={1}>
              <Grid item xs={12} md={6} mb={1}>
                <InputLabel
                  sx={{ paddingBottom: '8px', color: 'black', fontSize: '14px' }}
                  className="roboto-sans-medium"
                >
                  Name*
                </InputLabel>
                <TextField
                  id="name"
                  placeholder="Enter Your Name"
                  required
                  size="small"
                  fullWidth
                  type="text"
                  error={!!errors.name} // <- tells MUI to show error styling
                  helperText={errors.name?.message}
                  className="custom-textfield-booking "
                  name="name"
                  {...register('name', {
                    required: { value: true, message: 'Name is required' },
                  })}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#666666',
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} mb={1}>
                <InputLabel
                  sx={{ paddingBottom: '8px', color: 'black', fontSize: '14px' }}
                  className="roboto-sans-medium"
                >
                  Email*
                </InputLabel>
                <TextField
                  id="email"
                  size="small"
                  placeholder="Enter Email Address"
                  fullWidth
                  type="email"
                  className="custom-textfield-booking "
                  name="email"
                  error={!!errors.email} // <- tells MUI to show error styling
                  helperText={errors.email?.message}
                  {...register('email', {
                    required: { value: true, message: 'Email is required' },
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: 'Enter a valid email address',
                    },
                  })}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#666666',
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" spacing={1} mb={1}>
              <Grid item xs={12} md={6} mb={1}>
                <InputLabel
                  sx={{ paddingBottom: '8px', color: 'black', fontSize: '14px' }}
                  className="roboto-sans-medium"
                >
                  Phone Number*
                </InputLabel>
                <TextField
                  id="phone"
                  size="small"
                  placeholder="Enter Phone Number"
                  required
                  fullWidth
                  type="number"
                  className="custom-textfield-booking "
                  name="phone"
                  error={!!errors.phone}
                  helperText={errors.phone?.message}
                  // {...register('phone', {
                  //   required: { value: true, message: 'Phone Number is required' },
                  //   maxLength: 15,
                  //   minLength: 9,
                  // })}
                  {...register('phone', {
                    required: { value: true, message: 'Phone Number is required' },
                    maxLength: {
                      value: 15,
                      message: 'Phone Number cannot exceed 15 digits',
                    },
                    minLength: {
                      value: 9,
                      message: 'Phone Number must be at least 9 digits',
                    },
                  })}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#666666',
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mb={1}>
              <InputLabel
                sx={{ paddingBottom: '8px', color: 'black', fontSize: '14px' }}
                className="roboto-sans-medium"
              >
                Address*
              </InputLabel>
              <TextField
                id="address"
                size="small"
                placeholder="Enter Address"
                fullWidth
                multiline
                type="text"
                className="custom-textfield-booking "
                rows={4}
                name="address"
                error={!!errors.address} // <- tells MUI to show error styling
                helperText={errors.address?.message}
                {...register('address', {
                  required: { value: true, message: 'Address is required' },
                })}
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: '13.5px',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    fontSize: '13.5px',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#666666',
                    },
                  },
                }}
              />
              <Typography ml={2} variant="caption" className="roboto-sans-regular" sx={{ color: '#666666' }}>
                Flat No, Building Name, (Gate no. Optional)
              </Typography>
            </Grid>
            {/* <Grid item xs={12}>
              <InputLabel
                sx={{ paddingBottom: '8px', color: 'black', fontSize: '14px' }}
                className="roboto-sans-medium"
              >
                how many windows do you have?
              </InputLabel>
              <TextField
                id="remarks"
                size="small"
                placeholder="Type here.."
                fullWidth
                multiline
                type="text"
                className="custom-textfield-booking "
                rows={4}
                name="remarks"
                {...register('remarks', {
                  required: { value: false, message: 'Remark is required' },
                })}
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: '13.5px',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    fontSize: '13.5px',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#666666',
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ position: 'relative' }}>
              <Typography py={2} mb={6} className="roboto-sans-medium" fontSize={14} color="black">
                Location (Optional)
              </Typography>
           

              <div>
                <MyGoogleMap
                  MAP_PUBLIC_KEY={'AIzaSyAU4EsCpVhv88dQYuWU9enLuWLcQ3-Npo8'}
                  markers={markers}
                  setMarkers={setMarkers}
                  // locationMode={locationMode}
                />
              </div>
            </Grid> */}
            {/* <Stack>
              <Typography pt={3} pb={1} className="roboto-sans-medium" mb={1}>
                <Box component="span" sx={{ color: 'black', fontWeight: 500, fontSize: '15px', display: 'inline' }}>
                  Confirm Payment Method
                </Box>{' '}
                <Box component="span" sx={{ color: '#666666', fontSize: '15px', display: 'inline' }}>
                  (Optional)
                </Box>
              </Typography>
              <RadioGroup mt={2} value={payment} onChange={(e) => setPayment(e.target.value)}>
                {methods.map((method) => (
                  <Box
                    key={method.value}
                    sx={{
                      border: payment === method.value ? '2px solid #ec2927' : '1px solid #ccc',
                      borderRadius: '8px',
                      padding: ' 4px 4px',
                      marginBottom: '10px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <FormControlLabel
                      value={method.value}
                      control={
                        <Radio
                          sx={{
                            transform: 'scale(0.8)',
                            color: payment === method.value ? '#ec2927' : '#666666',
                            '&.Mui-checked': { color: '#ec2927' },
                          }}
                        />
                      }
                      label={
                        <Box>
                          <Typography className="roboto-sans-medium" sx={{ fontSize: '14px', fontWeight: 400 }}>
                            {method.label}
                          </Typography>
                          {method.miniText && (
                            <Typography className="roboto-sans-medium" sx={{ fontSize: '11px', color: '#888888' }}>
                              {method.miniText}
                            </Typography>
                          )}
                        </Box>
                      }
                      sx={{
                        marginLeft: 0,
                        '& .MuiFormControlLabel-label': {
                          fontSize: '14px',
                        },
                      }}
                    />
                  </Box>
                ))}
              </RadioGroup>
            </Stack> */}
            <Grid item xs={12} mt={2}>
              <CustomButton
                type="submit"
                variant="contained"
                className="roboto-sans-medium"
                size="medium"
                fullWidth
                sx={{ borderRadius: '8px', fontSize: '16px' }}
              >
                Confirm Booking{' '}
                {loading && <CircularProgress color="inherit" sx={{ color: 'white', mx: 2 }} size={'18px'} />}
              </CustomButton>
            </Grid>
            <Typography
              pt={2}
              lineHeight="normal"
              textAlign="center"
              className="caveat"
              fontSize="20px"
              color="#666666"
            >
              We’ll be in touch soon to bring the <br /> showroom to your living room.
            </Typography>
          </form>
        </Stack>
      </Stack>
      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleCalendarClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            boxShadow: 'none',
            borderRadius: '25px',
          },
        }}
      >
        <Box sx={{ borderRadius: '23px', backgroundColor: 'transparent' }}>
          <Stack
            sx={{
              border: `2px solid ${colors.primary}`,
              borderRadius: '23px',
              width: isMobile ? '250px' : '554px',
              height: isMobile ? '230px' : '521px',
            }}
            className="my-DateCalendar"
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateCalendar
                sx={{ width: '100%' }}
                value={selectedDate}
                onChange={(newValue) => {
                  setSelectedDate(newValue);
                  handleCalendarClose();
                }}
                disablePast
                maxDate={oneWeek}
                views={['day']}
                disableHighlightToday
                shouldDisableDate={(date) => moment(date).isSame(moment(), 'day')}
              />
            </LocalizationProvider>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
